import * as Yup from "yup";

export const validationSchema = Yup.object({
  firstname: Yup.string()
    .matches(/^[^0-9()]+$/, "Insira um nome válido")
    .min(
      3,
      "Por favor, verifique se o nome digitado possui entre 3 e 50 caracteres."
    )
    .max(
      50,
      "Por favor, verifique se o nome digitado possui entre 3 e 50 caracteres."
    )
    .required(`Para continuar é necessário preencher este campo.`),
  lastname: Yup.string()
    .matches(/^[^0-9()]+$/, "Insira um sobrenome válido")
    .min(
      3,
      "Por favor, verifique se o sobrenome digitado possui entre 3 e 100 caracteres."
    )
    .max(
      100,
      "Por favor, verifique se o sobrenome digitado possui entre 3 e 100 caracteres."
    )
    .required("Para continuar é necessário preencher este campo."),
  email: Yup.string()
    .email(
      "O e-mail inserido não é válido, por favor verifique e tente novamente."
    )
    .required("Para continuar é necessário preencher este campo."),
  country: Yup.string(),
  state: Yup.string(),
  city: Yup.string().test(
    "required",
    "Para continuar é necessário preencher este campo.",
    (value) => value !== "-1"
  ),
});

export const validationOtherCountrySchema = Yup.object({
  firstname: Yup.string()
    .matches(/^[^0-9()]+$/, "Insira um nome válido")
    .min(
      3,
      "Por favor, verifique se o nome digitado possui entre 3 e 50 caracteres."
    )
    .max(
      50,
      "Por favor, verifique se o nome digitado possui entre 3 e 50 caracteres."
    )
    .required(`Para continuar é necessário preencher este campo.`),
  lastname: Yup.string()
    .matches(/^[^0-9()]+$/, "Insira um sobrenome válido")
    .min(
      3,
      "Por favor, verifique se o sobrenome digitado possui entre 3 e 100 caracteres."
    )
    .max(
      100,
      "Por favor, verifique se o sobrenome digitado possui entre 3 e 100 caracteres."
    )
    .required("Para continuar é necessário preencher este campo."),
  email: Yup.string()
    .email(
      "O e-mail inserido não é válido, por favor verifique e tente novamente."
    )
    .required("Para continuar é necessário preencher este campo."),
  country: Yup.string()
  .required(`Para continuar é necessário selecionar o país.`),
});
